import React from 'react';
import { Helmet } from 'react-helmet';
import xhr from 'xhr.js';
import { withToastManager } from 'react-toast-notifications';
import services from 'services/services';

import BreadcrumbDivider from 'components/Breadcrumb/BreadcrumbDivider';
import { Link } from 'react-router-dom';
import H1 from 'components/H1';
import { Flex, Box, Button } from 'rebass';
import { Label } from '@rebass/forms';
import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';
import ParticipantSettings from 'components/Participant/ParticipantSettings';
import PastParticipation from 'components/Participant/PastParticipation';
import helpersStudy from 'utils/helpers-study';
import ReactModal from 'react-modal';
import { ReactFormGenerator } from 'components/ReactFormBuilder';

import { FiDollarSign, FiPlus, FiXCircle, FiTag } from 'react-icons/fi';

import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import SelectModal from 'components/SelectModal';
import helpers from 'utils/helpers';
import service_people from 'services/people';
import { COL_FIRST_NAME, COL_LAST_NAME, COL_EMAIL, COL_PHONE_NUMBER, COL_OPT_IN } from 'utils/constants';

import {
    Editor,
    EditorState,
    RichUtils,
    convertToRaw,
    convertFromRaw,
    getVisibleSelectionRect,
    Modifier,
    CompositeDecorator,
    SelectionState
} from 'draft-js';
import { convertFromHTML } from 'draft-convert';
import 'draft-js/dist/Draft.css';
import 'styles/draftjs-rich.css';

import moment from 'moment-timezone';

class ParticipantPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            participant: {},
            tags: [],
            tagSuggestions: [],
            showModalAddTag: false,
            showModalAddTag_loading: false,
            panelSignupAnswers: null
        };

        this.processDeleteData = this.processDeleteData.bind(this);
        this.getPersonXHR = this.getPersonXHR.bind(this);

    }

    getPersonXHR() {
        const { toastManager } = this.props;

        services
            .getPerson(this.props.match.params.id)
            .then(person => {
                const participant = person;

                this.setState({
                    participant,
                    loading: false
                });

                // return early if not found
                if (!person || !person.id) {
                    return;
                }

                const tags = [];

                // parse tags
                participant.tags.forEach(tag => {
                    tags.push({
                        id: tag.tag.id,
                        title: tag.tag.title
                    });
                });

                this.getPanelSignupAnswers();

                const that = this;

                this.setState({ tags }, () => {
                    // TODO: refactor this request to be made only when add tag button is clicked
                    helpers.getPersonTags(this.props.auth.account.id, (err, response) => {
                        if (err) {
                            alert('There was an error please try again.');
                        } else {
                            const suggestions = [];

                            response.forEach(tag => {
                                suggestions.push({
                                    id: tag.id,
                                    title: tag.title
                                });
                            });

                            const tagIds = tags.map(t => t.id);

                            // suggestions should not include tags already applied to the participant
                            // here, we filter them out
                            that.setState({
                                tagSuggestions: suggestions.filter(t => !tagIds.includes(t.id))
                            });
                        }
                    });
                });
            })
            .catch(error => {
                console.log(error);
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    componentDidMount() {
        this.getPersonXHR();
    }

    onTagAdd(tagId) {
        const { toastManager } = this.props;

        xhr.post(
            `/tags/${tagId}/people?account_id=${this.props.auth.account.id}`,
            { people_ids: { id: this.state.participant.id } },
            {
                withCredentials: true
            }
        )
            .then(res => {
                this.getPersonXHR();

                this.setState({ showModalAddTag: false });

                toastManager.add('Tag added successfully', {
                    appearance: 'success',
                    autoDismiss: true
                });
            })
            .catch(err => {
                const errorText = services.parseXhrErrors(err);
                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    onTagDelete(id) {
        const { toastManager } = this.props;

        xhr.delete(`/people/${this.props.match.params.id}/tags/${id}?account_id=${this.props.auth.account.id}`, {
            withCredentials: true
        }).then(res => {
            const tag = {
                id: res.data.id,
                title: res.data.title
            };

            this.setState({
                tags: this.state.tags.filter(t => t.id !== id),
                tagSuggestions: [tag, ...this.state.tagSuggestions]
            });

            toastManager.add('Tag deleted', {
                appearance: 'success',
                autoDismiss: true
            });
        })
        .catch(err => {
            const errorText = services.parseXhrErrors(err);
            toastManager.add(errorText, {
                appearance: 'error',
                autoDismiss: true
            });
        });
    }

    onTagCreate(title) {
        const { toastManager } = this.props;

        let tag = {
            title,
            account_id: this.props.auth.account.id,
            type: 'Person'
        };

        xhr.post(`/tags`, tag, { withCredentials: true })
        .then(response => {
            this.setState({ showModalAddTag: false });

            toastManager.add('Tag created', {
                appearance: 'success',
                autoDismiss: true
            });

            tag = response.data;
            this.onTagAdd(tag.id);
        })
        .catch(err => {
            const errorText = services.parseXhrErrors(err);
            toastManager.add(errorText, {
                appearance: 'error',
                autoDismiss: true
            });
        });
    }

    getPanelSignupAnswers(title) {
        const { toastManager } = this.props;

        xhr.get(`/people/${this.props.match.params.id}/panel-signup-answers?account_id=${this.props.auth.account.id}`, { withCredentials: true }).then(response => {
            this.setState({ panelSignupAnswers: response.data });
            //console.log(response.data)
        });
    }

    processDeleteData() {
        const { toastManager } = this.props;
        const account_uuid = this.props.auth.account.uuid;
        const person_uuid = this.state.participant.uuid;

        // eslint-disable-next-line
        if (confirm('Deleting this data is irreversible. Would you like to proceed?')) {
            service_people
                .consentDeleteData(account_uuid, person_uuid)
                .then(() => {
                    this.getPersonXHR();
                    toastManager.add('Panelist successfully deleted', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                })
                .catch(err => {
                    const errorText = services.parseXhrErrors(err);
                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    handleOpenModalAddTag() {
        this.setState({ showModalAddTag: true });
    }

    render() {
        const which_studies = <PastParticipation person={this.state.participant} />;

        let breadcrumbs_first_name = '';
        let breadcrumbs_last_name = '';
        if (this.state.participant.custom_data_values2) {
            breadcrumbs_first_name = this.state.participant.custom_data_values2[helpers.getPdkId(this.state.participant.custom_data_keys, COL_FIRST_NAME)];
            breadcrumbs_last_name = this.state.participant.custom_data_values2[helpers.getPdkId(this.state.participant.custom_data_keys, COL_LAST_NAME)];
        }

        return (
            <AppPageWrapper>
                <Helmet>
                    <title>Participant</title>
                </Helmet>

                <AppPageWrapperSectionHeader>
                    <H1 className='ellipsis'>
                        <Link to="/panel">Panel</Link>
                        {!this.state.loading && (
                            <>
                                <BreadcrumbDivider />
                                {this.state.participant.id
                                    ? `${breadcrumbs_first_name} ${breadcrumbs_last_name}`
                                    : 'Not Found'}
                            </>
                        )}
                    </H1>
                </AppPageWrapperSectionHeader>

                <AppPageWrapperSectionBody>
                    {/* eslint-disable-next-line */}
                    {this.state.loading ? (
                        <div style={{ width: '100%' }}>
                            <LoadingWrapper>
                                <LoadingIndicator />
                            </LoadingWrapper>
                        </div>
                    ) : !this.state.participant || !this.state.participant.id ? (
                        <Flex mx={4} mt={2}>
                            Panelist not found.
                        </Flex>
                    ) : (
                        <Flex mx={4} mt={2} mb={4} sx={{width: '100%', gridGap: 4}}>
                            <Box width={1/2}>
                                <Flex justifyContent='space-between'>
                                    <h3>Properties</h3>
                                    <Box fontSize={1} sx={{paddingTop: '4px'}}>
                                        {helpers.newFeatureTag(moment("01-23-2022", "MM-DD-YYYY"), {margin: '2px 8px 0 0'})}
                                        <Link to="/panel-data">
                                            Re-order properties
                                        </Link>
                                    </Box>
                                </Flex>
                                <ParticipantSettings participant={this.state.participant} />
                                <br />

                                {this.state.panelSignupAnswers && this.state.panelSignupAnswers.panel_form && this.state.panelSignupAnswers.panel_form.form && 
                                    <Box mb={4}>
                                        <h3>Original Panel Signup Answers</h3>
                                        <Box fontSize={1}>
                                            <Button type="button" variant="secondary-gray" onClick={() => this.setState({ showModalOriginalPanelAnswers: true})}>
                                                View Answers
                                            </Button>
                                        </Box>
                                    </Box>
                                }

                                <h3>Delete Panelist</h3>
                                <Box>
                                    <Label mb={2}>
                                        Permanently delete this profile, and all of the associated data.
                                    </Label>
                                    <Button type="button" variant="danger" onClick={this.processDeleteData}>
                                        Delete panelist
                                    </Button>
                                </Box>
                            </Box>
                            <Box width={1/2} fontSize={1}>
                                <Box mb={4}>
                                    <h3>Tags</h3>
                                    {this.state.tags.length ? 
                                        this.state.tags.map(tag => (
                                            <Button key={tag.id} variant="tertiary" mx={1} mb={2}>
                                                <FiTag />
                                                {tag.title} <FiXCircle onClick={() => this.onTagDelete(tag.id)} />
                                            </Button>
                                        ))
                                        : <Box fontSize={1} mt={3}>This person has no tags.</Box>
                                    }

                                    <Box mt={3}>
                                        <Button variant="secondary-gray" mx={1} onClick={() => this.handleOpenModalAddTag()}>
                                            <FiPlus /> Add tag
                                        </Button>
                                    </Box>

                                    <SelectModal
                                        type="tag"
                                        icon={<FiTag />}
                                        items={this.state.tagSuggestions}
                                        isOpen={this.state.showModalAddTag}
                                        isLoading={this.state.showModalAddTag_loading}
                                        onRequestClose={() => this.setState({ showModalAddTag: false })}
                                        onSelect={this.onTagAdd.bind(this)}
                                        onCreate={this.onTagCreate.bind(this)}
                                    />
                                </Box>
                            
                                <h3>Studies & Past Participation</h3>
                                {which_studies}
                            </Box>

                            {this.state.panelSignupAnswers && this.state.panelSignupAnswers.panel_form && this.state.panelSignupAnswers.panel_form.form && 
                                <ReactModal
                                    isOpen={this.state.showModalOriginalPanelAnswers}
                                    shouldCloseOnOverlayClick
                                    onRequestClose={() => this.setState({showModalOriginalPanelAnswers: false})}
                                >
                                    <Box m={4}>
                                        <H1 style={{marginBottom: 0}}>
                                            Original Panel Signup Answers
                                        </H1>
                                        <Box style={{fontSize: '13px !important'}}>
                                            <ReactFormGenerator
                                                data={this.state.panelSignupAnswers.panel_form.form}
                                                answer_data={JSON.parse(this.state.panelSignupAnswers.answers)}
                                                read_only={true}
                                                hide_actions={true}
                                            />
                                        </Box>
                                    </Box>
                                </ReactModal>
                            }
                        </Flex>
                    )}
                </AppPageWrapperSectionBody>
            </AppPageWrapper>
        );
    }
}

export default withToastManager(ParticipantPage);
